import { CellContext, createColumnHelper } from '@tanstack/react-table';
import { Users, Layers } from 'lucide-react';

import { useSettings } from '@/react/portainer/settings/queries/useSettings';

import { buildNameColumn } from '@@/datatables/buildNameColumn';
import { Button } from '@@/buttons';
import { Link } from '@@/Link';
import { TooltipWithChildren } from '@@/Tip/TooltipWithChildren';

import { EnvironmentGroup } from '../../types';

const columnHelper = createColumnHelper<EnvironmentGroup>();

export const columns = [
  buildNameColumn<EnvironmentGroup>('Name', '.group', 'environment-group-name'),
  columnHelper.display({
    header: 'Actions',
    cell: ActionsCell,
  }),
];

function ActionsCell({
  row: { original: item },
}: CellContext<EnvironmentGroup, unknown>) {
  const fleetManagementEnabled = useSettings(
    (settings) => settings.ExperimentalFeatures?.fleetManagement === true
  );

  const isFleetEnabled = fleetManagementEnabled.data ?? false;

  const managePoliciesButton = (
    <Button
      as={isFleetEnabled ? Link : 'button'}
      props={
        isFleetEnabled
          ? {
              to: 'portainer.policies',
              params: { id: item.Id },
            }
          : undefined
      }
      color="link"
      className="!pl-0"
      icon={Layers}
      disabled={!isFleetEnabled}
      data-cy={`manage-policies-button_${item.Name}`}
    >
      Manage policies
    </Button>
  );

  return (
    <div className="flex gap-x-2">
      {!isFleetEnabled ? (
        <TooltipWithChildren message="You must enable the Fleet management feature under the Experimental features first">
          <div className="inline-block">{managePoliciesButton}</div>
        </TooltipWithChildren>
      ) : (
        managePoliciesButton
      )}
      <Button
        as={Link}
        props={{
          to: '.group.access',
          params: { id: item.Id },
        }}
        color="link"
        icon={Users}
        data-cy={`manage-access-button_${item.Name}`}
      >
        Manage access
      </Button>
    </div>
  );
}
